<template>
    <div>
        <v-tabs v-model="step">
            <template v-for="tab in tabs">
                <v-tab :key="tab.id" ripple>Item {{ tab.id }}</v-tab>
                <v-tab-item class="text-sm-left pt-3 pr-3 pl-3" :key="tab.id" v-html="tab.content"></v-tab-item>
            </template>
        </v-tabs>
        <!--<v-layout row justify-center class="py-3">-->
        <!--<div v-for="n in 5" :key="n" :class="{active: n-1 == step}" class="mx-1 step"></div>-->
        <!--</v-layout>-->
    </div>
</template>

<script>
export default {
    name: 'ConsoleTour',
    data () {
        return {
            step: 0,
            maxStep: 4
        }
    },
    computed: {
        tabs () {
            return [
                { id: 1, content: this.$t('introduction.step1') },
                { id: 2, content: this.$t('introduction.step2') },
                { id: 3, content: this.$t('introduction.step3') },
                { id: 4, content: this.$t('introduction.step4') },
                { id: 5, content: this.$t('introduction.step5') }
            ]
        }
    },
    methods: {
        next () {
            if (this.step < this.maxStep) {
                this.step += 1
            }
        },
        back () {
            this.step -= 1
        },
        isFirst () {
            return this.step === 0
        },
        isLast () {
            return this.step === this.maxStep
        }
    }
}
</script>

<style scoped>
    /deep/ .v-tabs__bar {
        display: none;
    }

    .step {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #02AFC8;
    }

    .active {
        background: white;
    }
</style>
